module.exports = __webpack_public_path__ + "static/img/MelbourneVixens.fb37478.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MelbourneVixens.png
// module id = 3loN
// module chunks = 1